import '../../capabilities/registry';
import { registerDeployPlugin } from '../../core/registry';
import { registerResourceConfigs } from '../../platform/resource-watch';
import { registerSkuModuleMeta } from '../../platform/scene-layout/moduleMetaRegistry';
import { ebmHeadless } from './headless';
import { EBM_RESOURCE_CONFIGS, EBM_SKU_MODULE_META } from './resourceConfigs';

registerSkuModuleMeta('ElasticBareMetal', EBM_SKU_MODULE_META);
registerResourceConfigs('ElasticBareMetal', EBM_RESOURCE_CONFIGS);

registerDeployPlugin({
  headless: ebmHeadless,
  loadUi: () =>
    import('./ui').then((m) => ({
      ResourceEditor: m.EbmResourceEditor,
      ResourcePreview: m.EbmResourcePreview,
    })),
});

export { EBM_MODULES } from './modules';
export { EBM_FIELD_KEYS } from './fields';
export type { EbmFieldKey } from './fields';
export { resetEbmSkuModuleFields } from './skuModuleReset';
export {
  EBM_SCENES,
  EBM_ALL_MODULES,
  EBM_SKU_MODULES,
  EBM_SKU_MODULE_LIST,
  isEbmSkuModuleKey,
  EBM_ORDER_MODULES,
  EBM_DIRECT_CREATE_STEPS,
  EBM_DIRECT_MERGED_MODULES,
  filterEbmDirectMergedModules,
  buildEbmDirectResourceModulesFromForm,
  resolveEbmSceneConfig,
  filterEbmSkuModules,
} from './scenes';
export type { EbmDirectCreateStep, EbmDirectMergedModuleKey, EbmSkuModuleKey } from './scenes';
export {
  EBM_RESOURCE_CONFIGS,
  EBM_SKU_MODULE_META,
  ebmComputeTemplates,
  ebmElasticBareMetalNode,
  ebmCpu,
  ebmDataStorage,
  ebmGpu,
  ebmMemory,
  ebmNic,
  ebmNvme,
  ebmSystemStorage,
  resolveEbmResourceWatchFields,
  resolveEbmPricingResourceCodes,
} from './resourceConfigs';
export { buildEbmDeliveryMetadata, buildEbmOrderDeliveryMetadata } from './headless/deliveryMetadata';
export type { BuildEbmDeliveryMetadataInput, BuildEbmOrderDeliveryMetadataContext, EbmDeliveryMetadata } from './headless/deliveryMetadata';
export { parseEbmResourceConfiguration } from './headless/spec';

export { buildEbmFreshDisplayConfig } from './display';
export { buildEbmMergedDisplayConfig } from './display/mergeDisplayConfig';
export {
  EBM_PRODUCT_CARD_EXCLUDED_DISPLAY_IDS,
  filterEbmProductCardDisplayConfig,
  finalizeEbmSubmitDisplayConfig,
} from './display/productCard';
export {
  resolveEbmSkuPreviewExtraWatchFields,
  resolveEbmOrderPreviewExtraWatchFields,
  resolveEbmOrderInnerRootWatchFields,
} from './orderPreviewWatch';
export { buildEbmSkuCapabilityOptions } from './skuCapabilityOptions';
export { EbmResourceEditor, useEbmDeployFormLinkage } from './ui';
export type { EbmResourceEditorProps } from './ui';
export { EbmResourcePreview } from './ui';
export type { EbmLinkagePropsMap } from './linkage';
